// adapted from:
// https://stackoverflow.com/questions/950087/how-do-i-include-a-javascript-file-in-another-javascript-file

const loadScript = (url, callback, type = 'text/javascript', otherParams = []) => {
	// Adding the script tag to the head
	const head = document.head;
	let script = document.createElement('script');
	if (type) {
		script.type = type;
	}
	script.src = url;

	if (otherParams) {
		otherParams.forEach(item => {
			script[item.attr] = item.value;
		});
	}

	// Then bind the event to the callback function.
	// There are several events for cross browser compatibility.
	script.onreadystatechange = callback;
	script.onload = callback;

	// Fire the loading
	head.appendChild(script);
};

const loadStyle = (url) => {
	// Adding the script tag to the head
	const head = document.head;
	let style = document.createElement('link');
	style.rel = 'stylesheet';
	style.type = 'text/css';
	style.href = url;

	// Fire the loading
	head.appendChild(style);
};

export {loadScript, loadStyle};
